// extracted by mini-css-extract-plugin
export default {"overview":"style_overview__xkGAq","container":"style_container__BQUkp","submitContainer":"style_submitContainer__l1kdb","aboutUpdateContainer":"style_aboutUpdateContainer__hTAUG"};